import React, { useState, useEffect, useRef } from "react";
import * as th from "./tree_app.js"
import LoginPage from "./pages/login/LoginPage"
import { useSelector, useDispatch } from "react-redux";
import LandingPage from "./pages/login/LandingPage";
import RegisterPage from "./pages/login/RegisterPage";
import AppHeader from "./pages/component/AppHeader";
import AppMenu from "./pages/component/AppMenu";
import AppLoginPage from "./pages/component/AppLoginPage";
import AppRegisterPage from "./pages/component/AppRegisterPage";
import AppNoticePage from "./pages/component/AppNoticePage";
import { Box, Button, Grid, Paper, TextField } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import SamplePage from "./pages/sample/SamplePage";
import api from "./API";
import { setUserInfo } from "./redux/slice/user";
import WorkPage from "./pages/nki/WorkPage";
import EvalWorkerRouter from "./pages/eval-worker/EvalWorkerRouter";
import TzaWorkerRouter from "./pages/tza-worker/TzaWorkerRouter";
import VieWorkerRouter from "./pages/vie-worker/VieWorkerRouter";
import KhmWorkerRouter from "./pages/khm-worker/KhmWorkerRouter";
import SsbWorkerRouter from "./pages/ssb-worker/SsbWorkerRouter";

const App = () => {

  const dispatch = useDispatch();

  const contanerRef = useRef<HTMLDivElement>(null);

  const [switchPage , setSwitchPage] = useState(false);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  // console.log('app.tsx',auth.user.email)

  // console.log('app.tsx',auth)


  // const worker = auth.user.roles.some((obj:any) => obj.use_yn === 'Completed')

  const ssb_role = auth.user.roles.find((role:any) => ['SSB','SSB_PRC'].includes(role.role));

  const eval_role = auth.user.roles.find((role:any) => ['EVAL','EVAL_PRC','EVLT_PRC'].includes(role.role));

  const khm_role = auth.user.roles.find((role:any) => ['KHM','KHM_ISP','KHM_TRS'].includes(role.role));
  const tza_role = auth.user.roles.find((role:any) => ['TZA','TZA_ISP'].includes(role.role));

  const vie_role = auth.user.roles.find((role:any) => ['VIE','VIE_PRC','VIE_MANAGER'].includes(role.role));
  const nki_word_role = auth.user.roles.find((role:any) => ['script','sample_confirm','document_upload','work_start'].includes(role.use_yn));
  

  // console.log('nki_word_role', nki_word_role)
  // console.log('vie_role', vie_role)

  // console.log('worker',worker)

  const checkAuth = async () =>{
    const resp_data = await api.get('/@me',{params:{email:email}})
    // console.log('resp',resp_data.data)
    dispatch(setUserInfo(resp_data.data))
  }

  useEffect(() => {
    // th.start_tree()
    // checkAuth()
  },[]);

  return (
    <Box>
      <Box sx={{ backgroundColor: "#fff", height: "100%", maxWidth: "100%" }}>
        <AppHeader setSwitchPage={setSwitchPage} />
        <Routes>
          {nki_word_role ? 
          <Route path="/upload" element={<WorkPage />} />
          :
          <Route path="/upload" element={<SamplePage />} />
          }

          {ssb_role ? <Route path="/ssb-worker/*" element={<SsbWorkerRouter />} /> : "" }
          {eval_role ? <Route path="/eval-worker/*" element={<EvalWorkerRouter />} /> : "" }
          {tza_role ? <Route path="/tza-worker/*" element={<TzaWorkerRouter />} /> : "" }
          {khm_role ? <Route path="/khm-worker/*" element={<KhmWorkerRouter />} /> : "" }
          {vie_role ? <Route path="/vie-worker/*" element={<VieWorkerRouter />} /> : "" }
          
        {/* <AppMenu /> */}
          <Route path="/" element={
            auth.login ? <LandingPage /> : (<React.Fragment><AppLoginPage switchPage={switchPage} setSwitchPage={setSwitchPage} /> <AppRegisterPage switchPage={switchPage} setSwitchPage={setSwitchPage} /></React.Fragment>)       
            // auth.login ? <LandingPage /> : (<React.Fragment><AppLoginPage switchPage={switchPage} setSwitchPage={setSwitchPage} /> <AppNoticePage switchPage={switchPage} setSwitchPage={setSwitchPage} /></React.Fragment>)       
          } />
        </Routes>
      </Box>
    </Box>
    );
}

export default App;
